import { CardCheckbox } from '@/components/ui/CardCheckbox'
import { COVERAGE_TYPE_LABELS } from '@/models/insuranceCoverage'
import type { InsurancePolicy } from '@/models/insurancePolicy'
import { Vendor } from '@/models/insuranceTypes'
import type { PolicyChangePolicy } from '@/models/policyChange'

// A coverage type the app doesn't know yet shows as itself.
const LABELS: Partial<Record<string, string>> = COVERAGE_TYPE_LABELS

/** The customer's policies before a draft exists, in the shape a request lists them. */
export function policiesFromOrg(policies: InsurancePolicy[] | undefined): PolicyChangePolicy[] {
  return (policies ?? []).map((policy) => ({
    id: policy.id,
    coverages: policy.coverages.map((coverage) => LABELS[coverage.coverageType] ?? coverage.coverageType),
    carrierName: policy.vendorName,
    policyNumber: policy.vendorId,
    dateStart: policy.dateStart,
    dateEnd: policy.dateEnd,
    corgiEligible: policy.vendor === Vendor.CORGI,
  }))
}

/** Every policy in force, ticked and locked: a change goes on all of them or none. */
export function PoliciesIncluded({ policies }: { policies: PolicyChangePolicy[] }) {
  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm text-neutral-700">Your change goes on all of your policies.</p>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {policies.map((policy) => (
          <CardCheckbox key={policy.id} isChecked readOnly onChange={() => undefined}>
            <div className="font-medium">{policy.coverages.join(', ') || 'Policy'}</div>
            <div className="text-xs text-neutral-500">
              {[policy.carrierName, policy.policyNumber].filter(Boolean).join(' · ')}
            </div>
          </CardCheckbox>
        ))}
      </div>
    </div>
  )
}
